<script setup lang="ts">
defineProps<{ label?: string; hint?: string; error?: string; htmlFor?: string }>();
</script>
<template>
  <div class="cw-field">
    <label
      v-if="label"
      class="cw-field__label"
      :for="htmlFor"
    >{{ label }}</label>
    <slot />
    <span
      v-if="error || hint"
      class="cw-field__hint"
      :class="{ 'cw-field__hint--error': !!error }"
    >
      {{ error || hint }}
    </span>
  </div>
</template>
